export function tmDashboard(state = {
  eventLogDetailsReport: {
    data: [],
    pagination: {},
  }
}, action) {
  switch (action.type) {
    case "FETCH_TRANS_LOG_CHART_DATA":
      return {
        ...state,
        chartData: action.payload
      };
    case "FETCH_TRANS_LOG_EXCEL_DATA":
      return {
        ...state,
        chart_report: action.payload
      };
    case "FETCH_TRANS_LOG_REPORT_DATA":
      return {
        ...state,
        eventReport: action.payload.map((messageType) => (
          {
            ...messageType,
            ResendPercent: `${Math.round(messageType.Resend * 100 / messageType.Total)}%`,
            DELIVEREDPercent: `${Math.round(messageType.DELIVERED * 100 / messageType.Total)}%`,
            APIFail: messageType.FAILED - messageType.DataMissing,
            APIFailPercent: `${Math.round((messageType.FAILED - messageType.DataMissing) * 100 / messageType.Total)}%`,
            DataMissingPercent: `${Math.round(messageType.DataMissing * 100 / messageType.Total)}%`,
            PENDINGPercent: `${Math.round(messageType.PENDING * 100 / messageType.Total)}%`,
          }))
      };
    case 'FETCH_TRANS_EVENT_LOG_REPORT_DATA':
      return {
        ...state,
        eventLogDetailsReport: {
          data: action.payload?.data,
          pagination: action.payload?.pagination,
        }
      }
    default:
      return state
  }
}